import type { MapType } from '@racemap/utilities/consts/events';
import { mapStyles } from '@racemap/utilities/consts/map';
import { type FC, useEffect } from 'react';
import { useControl } from 'react-map-gl/mapbox';
import { ButtonGroupControl, type ControlButton } from './ButtonGroupControl';

interface Props {
  value: MapType | null;
  onChange?: (newStyle: MapType) => void;
}

class MapboxStyleControlClass extends ButtonGroupControl {
  onChange?: (newStyle: MapType) => void;
  value: MapType | null = null;

  constructor(value: MapType | null, onChange?: (newStyle: MapType) => void) {
    super('mapxboxgl-ctrl-style-chooser');
    this.value = value;
    this.onChange = onChange;
  }

  getButtons(): Array<ControlButton> {
    return Object.entries(mapStyles).map(([styleType, styleInfos]) => ({
      content: styleInfos.label,
      title: styleInfos.label,
      active: styleType === this.value,
      onClick: () => this.onChange?.(styleType as MapType),
    }));
  }
}

export const MapboxStyleControl: FC<Props> = ({ value, onChange }) => {
  const ctrl = useControl<MapboxStyleControlClass>(
    () => new MapboxStyleControlClass(value, onChange),
    {
      position: 'top-left',
    },
  );

  useEffect(() => {
    ctrl.value = value;
    ctrl.onChange = onChange;
    ctrl.render();
  }, [value, onChange, ctrl]);

  return null;
};
